<template>
  <div class="row">
    <a ref="attachmentA"></a>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <form @submit.prevent="save" v-if="entity">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label" for="messageId"
                        >Codice</label
                      >
                      <input
                        type="text"
                        class="form-control required"
                        id="messageId"
                        name="messageCode"
                        placeholder="Codice messaggio"
                        v-model="entity.messageCode"
                        :readonly="entity.systemTemplate"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="custom-control custom-checkbox custom-control-inline"
                    >
                      <input
                        v-model="entity.isTemplate"
                        type="checkbox"
                        id="isTemplate"
                        name="isTemplate"
                        class="custom-control-input"
                        :disabled="entity.systemTemplate"
                      />
                      <label class="custom-control-label" for="isTemplate"
                        >Modello di comunicazione</label
                      >
                      
                    </div>
                    <div class="alert alert-warning d-block mt-3">
                          <i>Se modello di comunicazione ricordarsi di inserire all'interno del contenuto la stringa {Body}</i>
                      </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label" for="type">Tipologia</label>
                      <select class="form-control" v-model="entity.type">
                        <option disabled value="">Seleziona un'opzione</option>
                        <option value="Text">Testo</option>
                        <option value="TextMultine">Testo multilinea</option>
                        <option value="Html">Testo HTML</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label class="col-form-label" for="type">Contenuto</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="entity.data"
                        v-if="entity.type == 'Text'"
                      />
                      <textarea
                        class="form-control"
                        rows="5"
                        v-model="entity.data"
                        v-if="entity.type == 'TextMultine'"
                      />
                      <editor
                        :api-key="tinyKey"
                        :init="{
                           remove_script_host: false,
                          convert_urls: false,
                          height: 500,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
                        }"
                        v-model="entity.data"
                        v-if="entity.type == 'Html'"
                      ></editor>
                    </div>
                  </div>
                </div>

                <div class="form-group mt-3">
                  <button
                    type="button"
                    class="btn btn-xs btn-primary m-1"
                    v-if="$store.getters.isInRole('template-edit')"
                    v-on:click="save"
                  >
                    Salva
                    <font-awesome-icon
                      :icon="['far', 'save']"
                    ></font-awesome-icon>
                  </button>
                  <button
                    type="button"
                    class="btn btn-xs btn-danger m-1"
                    v-on:click="cancel"
                  >
                    Annulla
                    <font-awesome-icon
                      :icon="['far', 'times-circle']"
                    ></font-awesome-icon>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.row [class*="col"] {
  transition: all 0.5s ease-in-out;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
export default {
  data() {
    return {
      entity: null,
    };
  },
  computed: {
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
  },
  components: {
    Editor,
  },
  name: "MessageSave",
  beforeMount() {
    var me = this;
    console.log("id", me.$route.params.id);

    axios
      .get(
        "messageTemplate/" + me.$route.params.id ||
          "00000000-0000-0000-0000-000000000000"
      )
      .then((response) => {
        me.entity = response.data;
        if (me.entity.messageCode != "")
          me.$store.state.breadCrump.title = me.entity.messageCode;
      });
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "route-messages",

        replace: true,
      });
    },

    save() {
      let me = this;
      axios.post("messagetemplate", this.entity).then((response) => {
        if (me.$route.params.id != response.data.messageTemplateId) {
          me.$router.push({
            name: "route-messagetemplate-edit",
            params: { id: response.data.messageTemplateId },
          });
        }

        me.$swal({
          title: "Salvataggio avvenuto correttamente",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
      });
    },
  },
};
</script>
